import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import JobForm from "@/components/JobForm";
import JobQuestionnaire from "@/components/JobQuestionnaire";

export default function JobEdit() {
    const { id } = useParams();
    const nav = useNavigate();
    const [busy, setBusy] = useState(false);
    const [initial, setInitial] = useState(null);

    useEffect(() => {
        api.get(`/jobs/${id}`)
            .then((r) => setInitial(r.data))
            .catch((e) => toast.error(formatApiError(e)));
    }, [id]);

    const submit = async (form) => {
        setBusy(true);
        try {
            await api.patch(`/jobs/${id}`, form);
            toast.success("Job updated");
            nav(`/jobs/${id}`);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally { setBusy(false); }
    };

    if (!initial) return <div className="p-8 font-mono text-sm text-foreground/80">Loading...</div>;

    return (
        <div className="max-w-[1600px] mx-auto px-3 sm:px-4 py-3 sm:py-5 space-y-8">
            <div>
                <div className="text-xs uppercase tracking-widest font-mono text-ikb">Edit job</div>
                <h1 className="font-display font-black text-2xl sm:text-4xl mt-2">{initial.title}</h1>
            </div>
            <JobForm mode="edit" initial={initial} onSubmit={submit} busy={busy} onCancel={() => nav(`/jobs/${id}`)} />
            <JobQuestionnaire jobId={id} />
        </div>
    );
}
